module.exports = __webpack_public_path__ + "static/media/sportnews.af5848ce.svg";